import { createFileRoute } from '@tanstack/react-router';
import { PortalProjects } from '@/features/portal/PortalProjects';

export const Route = createFileRoute('/_portal/portal/commesse')({ component: PortalProjects });
